<aside class="conversation-panel">
  <header class="conversation-panel__header">
    <h1>Chat</h1>
    <!-- Toolbar actions only affect local sidebar state, except new chat which bubbles to Home. -->
    <div class="header-tools">
      <button
        class="icon-button"
        type="button"
        aria-label="Search chats"
        [class.icon-button--active]="showSearch()"
        [attr.aria-expanded]="showSearch()"
        (click)="toggleSearch()"
      >
        <span class="material-icons">search</span>
      </button>
      <button class="icon-button" type="button" aria-label="Start new chat" (click)="onStartNewChat()">
        <span class="material-icons">edit_square</span>
      </button>
    </div>
  </header>

  <div class="chip-row" aria-label="Chat filters">
	<!-- Unread chip filters the already-provided chat list locally in the sidebar. -->
    <button
      class="chip"
      [class.chip--active]="unreadOnly()"
      type="button"
      (click)="toggleUnreadOnly()"
    >
      Unread
    </button>
  </div>

  @if (showSearch()) {
	<!-- Inline sidebar search is independent from the centered global header search. -->
    <label class="search-box" aria-label="Search people and groups">
      <span class="material-icons">search</span>
      <input
        type="search"
        placeholder="Search"
        [value]="searchQuery()"
        (input)="onSearchInput($event)"
      />
    </label>
  }

  <p class="section-title">Chats</p>

  <div class="conversation-list" aria-label="Recent chats">
	<!-- Selecting a card emits the full chat item so Home can update active channel state. -->
    @for (chat of filteredChats(); track chat.channelId ?? chat.name) {
      <button class="conversation-card" type="button" [class.active]="chat.name === selectedChatName()" (click)="onSelectChat(chat)">
        <app-user-hover-card
          [name]="getChatHoverName(chat)"
          [email]="getChatHoverEmail(chat)"
          [avatarUrl]="getChatHoverAvatarUrl(chat)"
          [initials]="chat.avatar"
          [accent]="chat.accent"
          [quickMessageUserId]="chat.participantUserId ?? null"
          [canQuickMessage]="!!chat.participantUserId"
        >
          <div class="avatar" [style.--avatar-accent]="chat.accent">
            <span class="avatar__media">
              @if (getChatHoverAvatarUrl(chat)) {
                <img [src]="getChatHoverAvatarUrl(chat)" [alt]="chat.name + ' profile photo'" />
              } @else {
                {{ chat.avatar }}
              }
            </span>
            @if (chat.presenceStatus) {
              <span
                class="presence-dot"
                [class]="'presence-dot presence-dot--' + chat.presenceStatus"
                [attr.title]="chat.presenceLabel || null"
                [attr.aria-label]="chat.presenceLabel || null"
              ></span>
            }
          </div>
        </app-user-hover-card>

        <div class="conversation-card__content">
          <div class="conversation-card__header">
            <h2>{{ chat.name }}</h2>
            @if ((chat.unread ?? 0) > 0) {
              <span class="conversation-card__badge">{{ chat.unread }}</span>
            }
          </div>
        </div>
      </button>
    }

    @if (filteredChats().length === 0) {
      <p class="conversation-list__empty">
        {{ unreadOnly() ? 'No unread chats found' : 'No chats found' }}
      </p>
    }
  </div>
</aside>
